import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=45077322&scoped=true&"
import script from "./dashboard.js?vue&type=script&lang=js&"
export * from "./dashboard.js?vue&type=script&lang=js&"
import style0 from "./dashboard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./dashboard.vue?vue&type=style&index=1&id=45077322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45077322",
  null
  
)

export default component.exports